// `extract.product`: a product read from its Shopify page (#249). The product form's
// Shopify import starts it and fills from its answer; live lists no such job, and
// a Studio draft never holds one.
import { ExtractProductQuote, ExtractProductRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"extract.product"> = {
  type: "extract.product",
  label: "Product from a store",
  source: "form",
  pair: "extract.product",
  fields: () => ({}),
  request: ExtractProductRequest,
  quote: ExtractProductQuote,
};
